
<template>
  <div class="title" style="margin: auto;justify-content: center">
    <div class="content-title">
      <div class="title-head">
        <div class="title-cn">客户资产与消费&amp;还款分析报告</div>
      </div>
    </div>
    <div class="title-foot1">
      <div class="bv-title">
        <span class="bv-title-cn">公司报告列表</span>
        <br>
<!--        <span class="bv-title-en">BILL VERIFICATION</span>-->
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="uploadColumns" :data="dataMap.comUploadRecord"></Table>
      </div>
    </div>
    <zhixiReportLtd ref="zhixiReportLtdRef" @handle-search="handleSearch"></zhixiReportLtd>
    </div>
</template>
<script>
import zhixiReportLtd from '../../../canalyse/company/zhixi-report.vue'
export default {
  name: 'content-upload',
  props: {
    dataMap: {
      type: Object
    }
  },
  components: {
    zhixiReportLtd
  },
  data () {
    return {
      uploadColumns:
        [{
          key: 'name',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '公司名')
            ])
          }
        }, {
          key: 'cardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-folder'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '帐号')
            ])
          }
        }, {
          key: 'crtTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-clock'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '创建时间')
            ])
          }
        }, {
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-settings'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '操作')
            ])
          },
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                icon: 'md-return-right'
              },
              on: {
                click: () => {
                  this.jumpPage(params.row)
                }
              }
            }, '跳转公司流水分析报告')
          }
        }]
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap)
  },
  methods: {
    setData (dataMap) {
      this.dataMap = dataMap
    },
    jumpPage (param) {
      this.$refs.zhixiReportLtdRef.openModel('detail', param)
    }
  }
}
</script>
